import { Layers } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";

export default function Ecosystem() {
  return (
    <section id="ecosysteme" className="py-16 sm:py-24 bg-[#141619]/40 border-y border-[#2E333D]/50" data-testid="ecosystem-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <Eyebrow>Empilage</Eyebrow>
            <SectionTitle>Construisez votre système de rangement.</SectionTitle>
            <p className="mt-6 text-gray-400 leading-relaxed max-w-lg">
              Le concept prévoit la possibilité d'empiler plusieurs boîtes afin de créer
              un système de rangement adapté à chaque professionnel.
            </p>
            <div className="mt-6 flex items-center gap-3 font-mono text-xs uppercase tracking-widest text-[#FFC700]">
              <Layers size={16} /> Système d'empilage — concept
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="border border-[#2E333D] rounded-2xl overflow-hidden bg-[#0C0D0E]" data-testid="stacking-image-frame">
              <img src="/images/stacking.jpg" alt="Concept d'empilage de trois STOCKBOX 8 verrouillées entre elles" className="w-full h-auto object-cover" loading="lazy" data-testid="stacking-image" />
            </div>
            <p className="mt-3 text-center font-mono text-[10px] uppercase tracking-widest text-gray-600">Visuel concept — non contractuel</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
